export const RACE = [
    {label: 'African American/Black', _id: '507f1f77bcf86cd799439071'},
    {label: 'Asian: Central Asian', _id: '507f1f77bcf86cd799439072'},
    {label: 'Asian: East Asian', _id: '507f1f77bcf86cd799439172'},
    {label: 'Asian: South Asian', _id: '507f1f77bcf86cd799439272'},
    {label: 'Asian: Southeast Asian', _id: '507f1f77bcf86cd799439472'},
    {label: 'Asian: West Asian', _id: '507f1f77bcf86cd799439372'},
    {label: 'Hawaiian Native/Pacific Islander', _id: '507f1f77bcf86cd799439073'},
    {label: 'Hispanic/Latino/a/x/e', _id: '507f1f77bcf86cd799439074'},
    {label: 'Native American/Alaskan Native', _id: '507f1f77bcf86cd799439075'},
    {label: 'Two or more races', _id: '507f1f77bcf86cd799439076'},
    {label: 'White', _id: '507f1f77bcf86cd799439077'},
    {label: 'Other', _id: '507f1f77bcf86cd799439078'},
    {label: 'Prefer Not to Answer', _id: '507f1f77bcf86cd799439079'},
];
